<template>
  <div class="column">
    <el-card v-loading="loading">
      <!--el-select v-model="instrumentType" :placeholder="$t('manual.selectInstrumentType')" @change="changeInstrumentType">
        <el-option
          v-for="item in instrumentTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select-->
      <el-cascader
        v-model="instrumentType"
        :options="instrumentType_options"
        :props="{ expandTrigger: 'hover' }"
        :placeholder="$t('manual.selectInstrumentType')"
        @change="changeInstrumentType"
      >
      </el-cascader>
      <el-cascader
        v-if="!isContinuityType && !kmrtRole"
        :key="instrumentCascaderKey"
        v-model="selectedInstrumentList"
        style="min-width:200px"
        :options="instrumentOptions"
        :props="props"
        :collapse-tags="true"
        :show-all-levels="false"
        :placeholder="$t('manual.selectInstrument')"
        @change="getCascaderInstrumentList"
      ></el-cascader>
      <el-select
        v-if="!isContinuityType && kmrtRole"
        v-model="area"
        placeholder="請選擇區域"
        @change="changeArea"
      >
        <el-option
          v-for="item in areaList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button v-if="!isContinuityType && kmrtRole" icon="el-icon-plus" @click="addArea">
        新增區域
      </el-button>
      <el-tooltip :content="$t('manual.tooltip.uploadInstrument')" placement="top">
        <el-button v-if="showOutputTable" @click="uploadInstrument">
          {{$t('manual.uploadInstrument')}}
        </el-button>
      </el-tooltip>
      <el-tooltip :content="$t('manual.tooltip.newRow')" placement="top">
        <el-button v-if="showOutputTable" @click="instrumentAdderDialogVisible=true">
          {{$t('manual.newRow')}}
        </el-button>
      </el-tooltip>
    </el-card>
    <el-card v-if="showOutputTable">
      <hot-table id="hot-container" ref="hot" root="hot" :settings="settings" />
    </el-card>
    <insturment-group 
      v-else-if="isSelectInstrumentType && isContinuityType && !loading" 
      :instrumentList="groupInstrumentList"
      :getInstrumentType="getInstrumentType"
    ></insturment-group>
    <el-dialog :visible="instrumentAdderDialogVisible" @close="instrumentAdderDialogVisible = false">
      <span>請選擇新增對象儀器</span>
      <el-button type="primary" @click="newInstrument(  1)">新增  1個欄位</el-button>
      <el-button type="primary" @click="newInstrument( 10)">新增 10個欄位</el-button>
      <el-button type="primary" @click="newInstrument(100)">新增100個欄位</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="instrumentAdderDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <frequency-setting-dialog
      :visible.sync="frequencySettingDialogVisible"
      :instrument-data="selectedInstrument"
      @save="handleSaveFrequencySetting"
    />
  </div>
</template>

<script>
import { HotTable } from '@handsontable/vue';
import Handsontable from 'handsontable';
import MomentTimeZone from 'moment-timezone';
import moment from 'moment';
import InsturmentGroup from '@/components/manual/InstrumentGroup.vue';
import FrequencySettingDialog from '@/components/manual/FrequencySettingDialog.vue';
import { EDIT_PASS_TABLE } from '@/constants/userRoles';
import { InstrumentTypeCascaderOption, TemplateDownloadLinkSelectOption } from '@/constants/instrumentTemplateDLOption';
import { clientVersion } from '@/constants/env';
import {
  createInstrumentCascadeProps,
  createLazyLoadInstrumentOptions,
  expandSelectedCascadeToInstruments,
  getCascadeAreas,
  getCascadeStations,
  getCascadeInstruments,
  getSelectedInstrumentValues,
} from '@/lib/base/instrumentCascade';
import manualProjectMixin from '@/lib/base/manualProject';

MomentTimeZone();
export default {
  mixins: [manualProjectMixin],
  components: {
    HotTable,
    InsturmentGroup,
    FrequencySettingDialog,
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    settings() {
      const vm = this;
      return {
        data: this.instrumentList,
        fixedColumnsLeft: 1,
        colHeaders: this.columnsHeader,
        rowHeaders: true,
        manualRowResize: true,
        manualColumnResize: true,
        manualRowMove: true,
        customBorders: true,
        columnSorting: true,
        height: 600,
        width: '100%',
        columns: this.columns,
        licenseKey: 'non-commercial-and-evaluation',
        cells(row, col) {
          if (this.instance.countCols() == 0 || this.instance.countRows() == 0) return;
          const cp = {};

          const colDef = vm.columns[col];
          const key = colDef && colDef.data;

          if (vm.isLCInstrumentType() && key === 'R0') {
            cp.readOnly = true;
          }

          const rowData = this.instance.getSourceDataAtRow(row);
          // 只有「這一列本身就是伺服器上已存在的資料」（帶有 _id）才視為既有資料列，
          // 避免使用者用「新增列」輸入已存在的儀器名稱（新增新版本）時，
          // 被誤判成在編輯舊資料而整列鎖住。
          const isExistingRow = !!rowData?._id;

          if (col === 0 && isExistingRow) {
            cp.readOnly = true;
          }
          if (!cp.readOnly && isExistingRow) {
            const pastWindow = vm.isPastEditWindow(rowData);
            if (!vm.editPass && pastWindow) {
              cp.readOnly = true;
            } else if (vm.editPass && pastWindow) {
              // admin/edit 檢視：此欄位對 client 角色而言已超過 1 日可編輯窗口
              cp.className = 'client-locked-cell';
              cp.clientLocked = true;
            }
          }
          return cp;
        },
        afterRenderer(TD, row, col, prop, value, cellProperties) {
          if (cellProperties.clientLocked) {
            TD.title = '此欄位已超過 client 角色可編輯的 1 日窗口，僅 admin/edit 角色可編輯';
          }
        },
        async beforeChange(changes, source) {
          for (let change of changes) {
            if (change[1] == 'startDate') {
              if (!isNaN(Number(change[3])) || isNaN(new Date(change[3]))) {
                vm.$notifyError('請輸入正確的日期');
                change[3] = '';
              } else {
                change[3] = moment(change[3]).format('yyyy-MM-DD HH:mm');
              }
            }
          }
        },
        afterChange(changes, source) {
          if (!changes || source === 'loadData' || source === 'auto') return;

          vm.autoFillArea(this, changes);
          vm.checkStationConflict(this, changes);

          if (!vm.isLCInstrumentType()) return;

          for (const [row, prop, oldVal, newVal] of changes) {
            if (!['gage1_initial', 'gage2_initial', 'gage3_initial'].includes(prop)) continue;

            const rowData = this.getSourceDataAtRow(row);

            const g1 = parseFloat(rowData.gage1_initial);
            const g2 = parseFloat(rowData.gage2_initial);
            const g3 = parseFloat(rowData.gage3_initial);

            const allValid = [g1, g2, g3].every(v => !isNaN(v));

            if (!rowData.other_value) rowData.other_value = {};

            if (allValid) {
              const avg = (g1 + g2 + g3) / 3;

              // 寫回 row 物件
              rowData.R0 = avg;
              rowData.other_value.gage1_initial = g1;
              rowData.other_value.gage2_initial = g2;
              rowData.other_value.gage3_initial = g3;
              rowData.other_value.avg_initial = avg;

              // 更新表格顯示（用自訂 source 避免再觸發一次 afterChange）
              this.setDataAtRowProp(row, 'R0', avg, 'auto');
            } else {
              rowData.R0 = null;
              rowData.other_value.avg_initial = null;
              this.setDataAtRowProp(row, 'R0', null, 'auto');
            }
          }
        },

        afterGetColHeader(col, TH) {
          const key = vm.columns[col] && vm.columns[col].data;

          if (key && key.includes('plus')) {
            if (TH) {
              TH.children[0].title = '+ 代表上限';
            }
          }
          if (key && key.includes('minus')) {
            if (TH) {
              TH.children[0].title = '- 代表下限';
            }
          }
        },
      };
    },
    isSelectInstrumentType(){
      return this.getInstrumentType;
    },
    kmrtRole(){
      return clientVersion === 'kmrt';
    },
    // kmrt 版本需要儀器類型 + 區域都選定後才顯示儀器清單
    showOutputTable(){
      return this.isSelectInstrumentType && !this.isContinuityType && (!this.kmrtRole || !!this.area);
    },
    getInstrumentType(){
      const instrumentType = this.instrumentType?.[1];
      return this.instrumentTypeList.find(ele=>{
        return ele.name === instrumentType;
      });
    },
    columns() {
      const vm = this;

      // 依照儀器類型過濾要顯示的欄位
      const visibleCols = this.col
        .filter(ele => vm.shouldShowColumn(ele.data));

      const result = visibleCols.map(ele => ({ ...ele }));

      // 最後一欄：頻率設定按鈕
      result.push({
        renderer(instance, td, row, col, prop, value, cellProperties) {
          Handsontable.dom.empty(td);
          const physicalRow = instance.toPhysicalRow(row);
          const rowData = instance.getSourceDataAtRow(physicalRow);

          const button = document.createElement('button');
          button.textContent = '顯示';
          button.className = 'htBtn';
          let timeoutSettings = rowData?.timeoutSetting;
          if(timeoutSettings && Array.isArray(timeoutSettings) && timeoutSettings.length > 0)
          {
            button.textContent = '已啟用頻率';
          }
          else{
            button.textContent = '未啟用頻率';
          }

          const instrumentName = rowData?.name;

          if ([null, undefined, ''].includes(instrumentName)) {
            button.disabled = true;
            button.className = 'htBtn htBtn-disabled';
            button.style.cursor = 'not-allowed';
          } else {
            button.addEventListener('click', () => {
              vm.showFrequencySettingPanel(instance, physicalRow);
            });
          }

          td.appendChild(button);
          return td;
        },
      });

      // 最後一欄：複製為新版本按鈕
      result.push({
        renderer(instance, td, row, col, prop, value, cellProperties) {
          Handsontable.dom.empty(td);
          const physicalRow = instance.toPhysicalRow(row);
          const rowData = instance.getSourceDataAtRow(physicalRow);

          const button = document.createElement('button');
          button.textContent = '複製為新版本';
          button.className = 'htBtn';

          const instrumentName = rowData?.name;

          if ([null, undefined, ''].includes(instrumentName)) {
            button.disabled = true;
            button.className = 'htBtn htBtn-disabled';
            button.style.cursor = 'not-allowed';
          } else {
            button.addEventListener('click', () => {
              vm.copyInstrumentAsNewVersion(physicalRow);
            });
          }

          td.appendChild(button);
          return td;
        },
      });

      return result;
    },
    columnsHeader() {
      const vm = this;

      const colMeta = this.col
        .map((ele, index) => ({
          data: ele.data,
          header: this.colHeader[index],
        }))
        .filter(ele => vm.shouldShowColumn(ele.data));

      const isLC = this.isLCInstrumentType();

      const result = colMeta.map(meta => {
        if (isLC && meta.data === 'R0') {
          return '平均初值(R0)';
        }
        return meta.header;
      });

      result.push('上傳頻率設定');
      result.push('複製為新版本');

      return result;
    },
    isContinuityType() {
      const instrumentTypeName = this.instrumentType?.[1];
      return this.continuityTypeCheck(instrumentTypeName);
    },
    useLazyInstrumentLoad(){
      return !!this.manualProject?.config?.use_lazy_instrument_load && !this.isContinuityType;
    },
    props(){
      return createInstrumentCascadeProps({
        lazy: this.useLazyInstrumentLoad,
        lazyLoad: this.lazyLoadInstrumentOptions,
      });
    },
    instrumentCascaderKey(){
      const type = Array.isArray(this.instrumentType) ? this.instrumentType.join('-') : this.instrumentType;
      // non-lazy: 不含 type，切換儀器類型時不重建 cascader，保留選取狀態
      // return `${this.useLazyInstrumentLoad ? 'lazy' : 'normal'}-${type || 'all'}`;
      return this.useLazyInstrumentLoad ? `lazy-${type || 'all'}` : 'normal';
    },
    userRole() {
      return this.$store.getters['user/details'].roles;
    },
    editPass() {
      return !!EDIT_PASS_TABLE[this.userRole];
    },
    instrumentType_options() {
      return InstrumentTypeCascaderOption.map(ele=>{
        return {
          value: ele.value,
          label: ele.label,
          children: ele.children.map(child=>{
            const instrumentType = this.instrumentTypeList.find(instrumentType=>{
              return child.value === instrumentType.name;
            });
            return {
              value: child.value,
              label: child.label,
              disabled: !instrumentType,
            };
          }),
        };
      });
    },
  },
  data(){
    return {
      constCol: [
        'name',
        'area',
        'station',
        'startDate',
        'unit',
        'WL_plus',
        'WL_minus',
        'AL_plus',
        'AL_minus',
        'WSL_plus',
        'WSL_minus',
        'coordinates_lng',
        'coordinates_lat',
        '',
      ],
      col: [
        { data: 'name' },
        { data: 'area' },
        { data: 'station' },
        { data: 'startDate' },
        { data: 'unit' },

        { data: 'R0' },               // 一般用於初值，當儀器類型為LC時 顯示 avg_initial，用於計算
        { data: 'gage1_initial' },    // Gage1 初值
        { data: 'gage2_initial' },    // Gage2 初值
        { data: 'gage3_initial' },    // Gage3 初值

        { data: 'A+' },
        { data: 'A-' },
        { data: 'offset' },
        { data: 'T0' },
        { data: 'K' },
        { data: 'F0' },
        { data: 'F1' },
        { data: 'F2' },
        { data: 'F3' },
        { data: 'F4' },
        { data: 'F5' },

        { data: 'WL_plus' },
        { data: 'WL_minus' },
        { data: 'AL_plus' },
        { data: 'AL_minus' },
        { data: 'WSL_plus' },
        { data: 'WSL_minus' },
        { data: 'coordinates_lng' },
        { data: 'coordinates_lat' },
      ],

      colHeader: [
        '儀器名稱',
        '區域',
        '測站',
        '初值日期',
        '單位',
        '初值(R0)',      // 這欄會顯示 avg_initial

        'Gage1 初值',
        'Gage2 初值',
        'Gage3 初值',

        'A+',
        'A-',
        '位移量',
        'T0',
        'K',
        'F0',
        'F1',
        'F2',
        'F3',
        'F4',
        'F5',
        '注意值(+)',
        '注意值(-)',
        '警戒值(+)',
        '警戒值(-)',
        '行動值(+)',
        '行動值(-)',
        '座標 經度',
        '座標 緯度',
      ],

      loading: false,
      instrumentLoading: false,
      typeLoading: false,

      instrumentTypeList: [],
      instrumentType: '',
      listMinCount: 20,
      instrumentList: [],
      originInstrumentList: [],
      groupInstrumentList: [],
      loadedInstrumentAreas: [],
      isFullInstrumentListLoaded: false,

      instrumentOptions: [],
      selectedInstrumentList: [],
      area: '',
      areaList: [],
      // kmrt：使用者新增、但尚未有任何儀器上傳的區域名稱（區域只存在於儀器資料上，上傳儀器後才會真正保存）
      pendingAreas: [],
      // kmrt：使用者已確認「仍要使用」的同名測站（`區域__測站`），同一組合不重複詢問
      confirmedStationKeys: [],

      instrumentAdderDialogVisible: false,
      frequencySettingDialogVisible: false,

      selectedInstrument: {},

      frequencySettingPanel: {
        row: -1,
        target: null,
        targetName: '',
        startDate: '',
        settingData: [],
      },
    };
  },
  mounted(){
    this.getInstrumentTypeList();
    this.getInstruments();
    if (this.kmrtRole) this.getAreaList();
  },
  watch: {
    instrumentLoading() {
      this.loading = this.instrumentLoading || this.typeLoading;
    },
    typeLoading() {
      this.loading = this.instrumentLoading || this.typeLoading;
    },
  },
  methods: {
    continuityTypeCheck(instrumentTypeName){
      if(!instrumentTypeName) return false;
      return instrumentTypeName.includes('SIS') || instrumentTypeName.includes('SID') || instrumentTypeName.includes('ISS (傾斜)');
    },
    async getInstrumentTypeList(){
      this.typeLoading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: 'instrument_type',
      });
      this.instrumentTypeList = res.data.filter(ele => ele.manual).map(ele=>{
        return {
          ...ele,
          value: ele.name,
          label: ele.name,
        };
      }).sort((a,b) => a.value[0].localeCompare(b.value[0]));
      
      this.typeLoading = false;
    },
    async getInstruments() {
      this.instrumentLoading = true;
      if (this.useLazyInstrumentLoad) {
        this.originInstrumentList = [];
        this.groupInstrumentList = [];
        this.loadedInstrumentAreas = [];
        this.isFullInstrumentListLoaded = false;
        this.instrumentOptions = [];
        this.selectedInstrumentList = [];
        this.instrumentLoading = false;
        return;
      }

      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrument/${this.manualProjectId}`,
      });
      this.setManualInstrumentData(res.data, true);
      this.isFullInstrumentListLoaded = true;
      this.initCascaderSelector();
      this.instrumentLoading = false;
    },
    setManualInstrumentData(instruments, reset = false) {
      const loadedNames = new Set(this.originInstrumentList.map(ins => ins.name));
      const loadedGroupIds = new Set(this.groupInstrumentList.map(ins => String(ins._id)));
      const targetOriginInstrumentList = reset ? [] : this.originInstrumentList.slice();
      const targetGroupInstrumentList = reset ? [] : this.groupInstrumentList.slice();

      this.groupInstrumentList = [];
      this.originInstrumentList = instruments.reduce((acc, cur) => {
        if(this.continuityTypeCheck(cur?.instrument_type?.name)){
          if(!reset && loadedGroupIds.has(String(cur._id))) return acc;
          const singleGroupInstrument = {
            _id: cur._id,
            area: cur.area,
            station: cur.station,
            instrument_type: cur.instrument_type,
            timeoutSetting: cur.timeoutSetting,
            created_at: cur.created_at,
          };
          singleGroupInstrument.data = cur.data.map(ele=>{
            return {
              name: ele.name,
              startDate: ele.startDate ? moment(ele.startDate).format('yyyy-MM-DD HH:mm') : '',
              unit: ele.unit,
              R0: ele.R0,
              offset: ele.offset,
              T0: ele.T0,
              K: ele.K,
              F0: ele.F0,
              F1: ele.F1,
              F2: ele.F2,
              F3: ele.F3,
              F4: ele.F4,
              F5: ele.F5,
              'A+': ele['A+'],
              'A-': ele['A-'],
              WL_plus: ele.WL_plus,
              WL_minus: ele.WL_minus,
              AL_plus: ele.AL_plus,
              AL_minus: ele.AL_minus,
              WSL_plus: ele.WSL_plus,
              WSL_minus: ele.WSL_minus,
              coordinates_lng: ele.coordinates && ele.coordinates[0],
              coordinates_lat: ele.coordinates && ele.coordinates[1],
              created_at: ele.created_at,
            };
          });
          targetGroupInstrumentList.push(singleGroupInstrument);
        }
        else{
          cur.data.forEach(ele => {
            if(!reset && loadedNames.has(ele.name)) return;
            const row = {
              _id: cur._id,
              name: ele.name,
              area: cur.area,
              station: cur.station,
              startDate: ele.startDate ? moment(ele.startDate).format('yyyy-MM-DD HH:mm') : '',
              unit: ele.unit,
              R0: ele.R0,
              offset: ele.offset,
              T0: ele.T0,
              K: ele.K,
              F0: ele.F0,
              F1: ele.F1,
              F2: ele.F2,
              F3: ele.F3,
              F4: ele.F4,
              F5: ele.F5,
              'A+': ele['A+'],
              'A-': ele['A-'],
              WL_plus: ele.WL_plus,
              WL_minus: ele.WL_minus,
              AL_plus: ele.AL_plus,
              AL_minus: ele.AL_minus,
              WSL_plus: ele.WSL_plus,
              WSL_minus: ele.WSL_minus,
              instrument_type: cur.instrument_type,
              timeoutSetting: cur.timeoutSetting,
              coordinates_lng: ele.coordinates && ele.coordinates[0],
              coordinates_lat: ele.coordinates && ele.coordinates[1],
              created_at: ele.created_at,
            };

            // ★ 從 other_value 還原 gage 初值與 avg_initial
            if (ele.other_value) {
              row.other_value = ele.other_value;
              if (ele.other_value.gage1_initial !== undefined) {
                row.gage1_initial = ele.other_value.gage1_initial;
              }
              if (ele.other_value.gage2_initial !== undefined) {
                row.gage2_initial = ele.other_value.gage2_initial;
              }
              if (ele.other_value.gage3_initial !== undefined) {
                row.gage3_initial = ele.other_value.gage3_initial;
              }
              if (ele.other_value.avg_initial !== undefined && ele.other_value.avg_initial !== null) {
                // R0 顯示 avg_initial
                row.R0 = ele.other_value.avg_initial;
              }
            }

            acc.push(row);
          });
        }
        return acc;
      }, targetOriginInstrumentList);

      this.groupInstrumentList = targetGroupInstrumentList;

      this.originInstrumentList = this.originInstrumentList.sort((a, b) => {
        const nameCmp = a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
        if (nameCmp !== 0) return nameCmp;
        return a.startDate - b.startDate;
      });
    },
    getCascadeAreas(){
      return getCascadeAreas({
        axios: this.$axios,
        projectId: this.manualProjectId,
      });
    },
    getCascadeStations(area){
      return getCascadeStations({
        axios: this.$axios,
        projectId: this.manualProjectId,
        area,
      });
    },
    getCascadeInstruments(area, station){
      return getCascadeInstruments({
        axios: this.$axios,
        projectId: this.manualProjectId,
        area,
        station,
        instrumentType: this.getInstrumentType,
        valueKey: 'name',
      });
    },
    async getManualInstrumentByType(){
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrumentByType/${this.manualProjectId}/${this.getInstrumentType._id}`,
      });
      this.setManualInstrumentData(res.data, true);
      this.loadedInstrumentAreas = [];
      this.isFullInstrumentListLoaded = false;
    },
    async lazyLoadInstrumentOptions(node, resolve){
      return createLazyLoadInstrumentOptions({
        getAreas: this.getCascadeAreas,
        getStations: this.getCascadeStations,
        getInstruments: this.getCascadeInstruments,
      })(node, resolve);
    },
    async expandSelectedCascadeToInstruments(){
      if(!this.useLazyInstrumentLoad || this.selectedInstrumentList.length === 0) return;
      this.selectedInstrumentList = await expandSelectedCascadeToInstruments({
        selectedList: this.selectedInstrumentList,
        getStations: this.getCascadeStations,
        getInstruments: this.getCascadeInstruments,
      });
    },
    // kmrt 專用：區域下拉選單（取代原本的區域-測站-儀器聯集選擇器）
    async getAreaList(){
      const serverAreas = await this.getCascadeAreas();
      const serverAreaNames = new Set(serverAreas.map(area => area.value));
      // 已有儀器上傳的區域會出現在後端清單，不再視為待保存
      this.pendingAreas = this.pendingAreas.filter(name => !serverAreaNames.has(name));
      this.areaList = [
        ...serverAreas,
        ...this.pendingAreas.map(name => ({ label: `${name}（尚無儀器）`, value: name })),
      ];
    },
    // kmrt 專用：新增區域。區域只是儀器上的欄位，這裡先加進選單並選取，待使用者在該區域上傳儀器後才會保存
    async addArea(){
      let value;
      try {
        ({ value } = await this.$prompt('請輸入區域名稱', '新增區域', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          inputValidator: val => {
            const name = (val || '').trim();
            if (!name) return '請輸入區域名稱';
            if (this.areaList.some(area => area.value === name)) return '此區域已存在';
            return true;
          },
        }));
      } catch (e) {
        return;
      }
      const name = value.trim();
      this.pendingAreas.push(name);
      this.areaList.push({ label: `${name}（尚無儀器）`, value: name });
      this.area = name;
      await this.changeArea();
      this.$notifySuccess(`已新增區域「${name}」，請在此區域上傳至少一筆儀器後才會保存`);
    },
    // kmrt 專用：在已選定區域下填寫儀器時，自動帶入區域欄位；整列被清空時一併清掉自動帶入的區域，
    // 避免只剩區域的列在上傳時被當成「未輸入儀器名稱」
    autoFillArea(hot, changes){
      if (!this.kmrtRole || !this.area) return;
      const rows = new Set();
      for (const [row, prop] of changes) {
        if (prop !== 'area') rows.add(row);
      }
      rows.forEach(row => {
        const rowData = hot.getSourceDataAtRow(hot.toPhysicalRow(row)) || {};
        const hasValue = Object.entries(rowData).some(([key, val]) => {
          return key !== 'area' && typeof val !== 'object' && val !== undefined && val !== '';
        });
        const isEmptyArea = [null, undefined, ''].includes(rowData.area);
        if (hasValue && isEmptyArea) {
          hot.setDataAtRowProp(row, 'area', this.area, 'auto');
        } else if (!hasValue && !rowData._id && rowData.area === this.area) {
          hot.setDataAtRowProp(row, 'area', '', 'auto');
        }
      });
    },
    // kmrt 專用：取得「測站名稱 → 已存在於哪些區域」對照表（向後端查各區域的測站，結果快取到下次上傳成功為止）
    // 查詢失敗時回傳空表（不阻擋輸入，只是不提示）
    getStationAreaMap(){
      const areas = this.areaList.map(area => area.value).filter(name => !this.pendingAreas.includes(name));
      // 區域清單還沒載入完時不快取，避免之後一直沒有提示
      if (areas.length === 0) return Promise.resolve(new Map());
      if (!this.stationAreaMapPromise) {
        this.stationAreaMapPromise = Promise.all(
          areas.map(async area => ({ area, stations: await this.getCascadeStations(area) })),
        )
          .then(results => {
            const map = new Map();
            results.forEach(({ area, stations }) => {
              stations.forEach(station => {
                if (!map.has(station.value)) map.set(station.value, []);
                map.get(station.value).push(area);
              });
            });
            return map;
          })
          .catch(error => {
            console.error('取得各區域測站失敗，略過同名測站檢查', error);
            this.stationAreaMapPromise = null;
            return new Map();
          });
      }
      return this.stationAreaMapPromise;
    },
    // kmrt 專用：測站欄位輸入後，若該名稱已存在於其他區域（且不存在於本列區域），跳出確認；
    // 取消則還原成輸入前的值。測站歸屬由後端依名稱判定，同名測站可能被掛到錯誤的區域。
    async checkStationConflict(hot, changes){
      if (!this.kmrtRole || this.isContinuityType) return;
      const targets = [];
      for (const [row, prop, oldVal, newVal] of changes) {
        if (prop !== 'station' || oldVal === newVal) continue;
        const station = String(newVal ?? '').trim();
        if (!station) continue;
        const rowData = hot.getSourceDataAtRow(hot.toPhysicalRow(row)) || {};
        targets.push({ row, oldVal, station, area: rowData.area || this.area });
      }
      if (targets.length === 0) return;

      const stationAreaMap = await this.getStationAreaMap();
      const conflicts = targets
        .map(target => ({
          ...target,
          otherAreas: stationAreaMap.get(target.station) || [],
        }))
        .filter(target => {
          if (this.confirmedStationKeys.includes(`${target.area}__${target.station}`)) return false;
          return target.otherAreas.length > 0 && !target.otherAreas.includes(target.area);
        });
      if (conflicts.length === 0) return;

      const lines = conflicts
        .filter((target, index, list) => list.findIndex(t => t.area === target.area && t.station === target.station) === index)
        .slice(0, 5)
        .map(target => `測站「${target.station}」已存在於區域：${target.otherAreas.join('、')}（本列區域：${target.area || '未指定'}）`);
      const more = conflicts.length > 5 ? '\n…（僅列出前 5 筆）' : '';
      try {
        await this.$confirm(
          `${lines.join('\n')}${more}\n\n在不同區域使用同名測站，可能造成測站歸屬到錯誤的區域。確定要使用嗎？`,
          '測站名稱重複',
          {
            confirmButtonText: '仍要使用',
            cancelButtonText: '取消輸入',
            type: 'warning',
            customClass: 'station-conflict-confirm',
          },
        );
        conflicts.forEach(target => this.confirmedStationKeys.push(`${target.area}__${target.station}`));
      } catch (e) {
        if (hot.isDestroyed) return;
        conflicts.forEach(target => hot.setDataAtRowProp(target.row, 'station', target.oldVal ?? '', 'auto'));
      }
    },
    applyAreaSelection(){
      if (this.useLazyInstrumentLoad) {
        // lazy 模式：交給既有的 expandSelectedCascadeToInstruments 去後端展開該區域全部儀器
        // （尚無儀器的新區域後端查不到，不需展開）
        this.selectedInstrumentList = this.area && !this.pendingAreas.includes(this.area) ? [[this.area]] : [];
        return;
      }
      const typeId = this.getInstrumentType?._id;
      this.selectedInstrumentList = this.area
        ? this.originInstrumentList
          .filter(ins => ins.area === this.area && (!typeId || ins.instrument_type?._id == typeId))
          .map(ins => [ins.area, ins.station, ins.name])
        : [];
    },
    async changeArea(){
      this.applyAreaSelection();
      await this.getCascaderInstrumentList();
    },
    getSelectedInstrumentNames(){
      return getSelectedInstrumentValues(this.selectedInstrumentList);
    },
    initCascaderSelector() {
      this.instrumentOptions = [];
      this.selectedInstrumentList = [];

      let areas = {};

      this.originInstrumentList.forEach(ins=>{
        if(areas[ins.area]){
          areas[ins.area].push(ins);
        }
        else areas[ins.area] = [ins];
      });

      let instrumentOptions = [];

      for(let key of Object.keys(areas)){
        areas[key] = areas[key].reduce((acc,cur)=>{
          let index = acc.stations.findIndex(ele => ele.station === cur.station);
          if(index < 0){
            acc.stations.push({
              station: cur.station,
              instruments: [cur],
            });
          }
          else{
            if(acc.stations[index].instruments.findIndex(ele=> ele.name === cur.name) < 0)
              acc.stations[index].instruments.push(cur);
          }
          return acc;
        },{ stations: []});

        instrumentOptions.push({
          label: key,
          value: key,
          //disabled: areas[key].stations.length === 0,
          children: areas[key].stations.map((station)=>{
            return {
              label: station.station,
              value: station.station,
              //disabled: station.instruments.length === 0,
              children: station.instruments.map(ins=>{
                return {
                  label: ins.name,
                  value: ins.name,
                  leaf: true,
                };
              }),
            };
          }),
        });
      }

      this.instrumentOptions = instrumentOptions;
    },
    newInstrument(count){
      for(let i=0; i<count; i++){
        this.instrumentList.push({});
      }
      this.instrumentAdderDialogVisible = false;
    },
    async uploadInstrument(){
      this.instrumentLoading = true;
      // kmrt：每列的區域必須等於目前選擇的區域，避免儀器（與測站）被送進其他區域
      const checkAreaMatch = this.kmrtRole && !this.isContinuityType;
      const areaMismatches = [];
      for(let index in this.instrumentList){
        let ins = this.instrumentList[index];
        let isnull = Object.keys(ins).length == 0 || Object.values(ins).reduce((accumulator, currentValue) => accumulator && [''].includes(currentValue),true);
        if(isnull) continue;
        if([null,undefined,''].includes(ins.name)){
          this.$notifyError('未輸入儀器名稱');
          this.instrumentLoading = false;
          return;
        }
        if([null,undefined,''].includes(ins.startDate)){
          this.$notifyError('未輸入初值日期');
          this.instrumentLoading = false;
          return;
        }
        if(checkAreaMatch && ins.area !== this.area){
          areaMismatches.push(`第 ${Number(index) + 1} 列（${ins.name}）區域為「${[null, undefined, ''].includes(ins.area) ? '空白' : ins.area}」`);
        }
        else if([null,undefined,''].includes(ins.area)){
          this.$notifyInfo('未輸入區域名稱');
        }
        if([null,undefined,''].includes(ins.station)){
          this.$notifyInfo('未輸入測站名稱');
        }
        let flag = false;
        for(let j = 0; j < index; j++){
          flag = flag || (this.instrumentList[j].name == ins.name && this.instrumentList[j].startDate == ins.startDate);
        }
        if(flag){
          this.$notifyError('存在相同初值日期的儀器名稱');
          this.instrumentLoading = false;
          return;
        }
        if(['',null,undefined,NaN].includes(ins.F1)) ins.F1 = '1';
      }

      if(areaMismatches.length > 0){
        const shown = areaMismatches.slice(0, 5).join('；');
        const more = areaMismatches.length > 5 ? `…等共 ${areaMismatches.length} 列` : '';
        this.$notifyError(`以下列的區域與目前選擇的區域「${this.area}」不一致，請修正後再上傳：${shown}${more}`);
        this.instrumentLoading = false;
        return;
      }

      let instrumentList = this.instrumentList.filter(ins=>{
        let isnull = Object.keys(ins).length == 0 || Object.values(ins).reduce((accumulator, currentValue) => accumulator && [''].includes(currentValue),true);
        return !isnull;
      });

      console.log(this.instrumentList);
      console.log(instrumentList);

      // 後端會拒絕空的 insturments，這裡先擋下，避免全是空白列時送出請求
      if(instrumentList.length === 0){
        this.$notifyInfo('沒有可上傳的儀器，請先輸入資料');
        this.instrumentLoading = false;
        return;
      }

      const vm = this;                 // 保留 this
      const isLC = vm.isLCInstrumentType();

      function toNumOrUndef(v) {
        if (v === '' || v === null || v === undefined) return undefined;
        const n = Number(v);
        return Number.isFinite(n) ? n : undefined;
      }
      function normalizeLC(ins) {
        if (!isLC) {
          // 不用 LC：確保不送 other_value（或送 null 讓後端刪）
          const { other_value, gage1_initial, gage2_initial, gage3_initial, ...rest } = ins;
          return rest;
        }

        const g1 = toNumOrUndef(ins?.other_value?.gage1_initial ?? ins.gage1_initial);
        const g2 = toNumOrUndef(ins?.other_value?.gage2_initial ?? ins.gage2_initial);
        const g3 = toNumOrUndef(ins?.other_value?.gage3_initial ?? ins.gage3_initial);

        const hasAny = [g1, g2, g3].some(v => v !== undefined);
        const avg = [g1, g2, g3].every(v => v !== undefined) ? (g1 + g2 + g3) / 3 : undefined;
     
        const { gage1_initial, gage2_initial, gage3_initial, ...rest } = ins;
     
        if (!hasAny) {
          // 使用者沒填 gage：就不要強塞 other_value（避免存空物件）
          return rest;
        }

        // 把扁平欄位搬到 other_value
        const other_value = {
          ...(ins.other_value || {}),
          gage1_initial: g1,
          gage2_initial: g2,
          gage3_initial: g3,
          avg_initial: avg,
        };

        // 依你的需求：R0 顯示 avg_initial 且 readonly
        Object.keys(other_value).forEach(k => other_value[k] === undefined && delete other_value[k]);
        return {
          ...rest,
          // 依你的需求：R0 顯示 avg_initial
          R0: avg ?? rest.R0,
          other_value: Object.keys(other_value).length ? other_value : undefined,
        };
      }

      instrumentList = instrumentList.map(normalizeLC);
      console.log('[upload payload] sample', instrumentList?.[0]);

      try {
        await this.$axios({
          category: 'manual',
          method: 'put',
          apiName: 'addManualInstrument',
          data: {
            insturments: instrumentList,
            project_id: this.manualProjectId,
            instrumentType: this.getInstrumentType,
          },
        });
      } catch (error) {
        // 後端驗證失敗（400）時會附上 message，顯示給使用者並解除讀取狀態，保留表格內容讓使用者修正
        this.$notifyError(error);
        this.instrumentLoading = false;
        return;
      }
      await this.getInstruments();
      // 上傳後各區域的測站可能已變動，下次輸入測站時重新查詢
      this.stationAreaMapPromise = null;
      if (this.kmrtRole) await this.getAreaList();
      if(this.getInstrumentType) await this.changeInstrumentType();
      this.$notifySuccess('新增成功');
      this.instrumentLoading = false;
    },
    async changeInstrumentType(){
      if(!this.getInstrumentType) return;

      this.instrumentLoading = true;
      try {
        this.instrumentOptions = [];
        // non-lazy: 保留選取狀態，不清空
        if (this.useLazyInstrumentLoad) {
          this.selectedInstrumentList = [];
          console.log('non-lazy: 保留選取狀態，不清空 selectedInstrumentList');
        }
        // this.selectedInstrumentList = [];

        if (this.manualProject?.config?.use_lazy_instrument_load) {
          await this.getManualInstrumentByType();
        }
        else if (this.isContinuityType && !this.isFullInstrumentListLoaded) {
          const res = await this.$axios({
            category: 'manual',
            method: 'get',
            apiName: `getManualInstrument/${this.manualProjectId}`,
          });
          this.setManualInstrumentData(res.data, true);
          this.isFullInstrumentListLoaded = true;
        }
        else if (!this.isContinuityType) {
          const savedSelection = this.selectedInstrumentList.slice();
          this.initCascaderSelector();
          this.selectedInstrumentList = savedSelection;
        }

        if (this.kmrtRole && this.area && !this.isContinuityType) {
          // kmrt：用新儀器類型 + 既有已選區域，重新算 selectedInstrumentList 並刷新
          await this.changeArea();
        } else {
          this.applyInstrumentFilter();
        }
      } finally {
        this.instrumentLoading = false;
      }
    },
    applyInstrumentFilter(){
      if (!this.getInstrumentType) return;
      if (this.kmrtRole && !this.isContinuityType && !this.area) {
        // kmrt：儀器類型 + 區域都選定前，不列出任何儀器
        this.instrumentList = [];
        this.updateTable();
        return;
      }
      const selectedInstrumentNames = this.getSelectedInstrumentNames();
      this.instrumentList = this.originInstrumentList.filter(ele=> {
        //console.log(ele.instrument_type);
        if (ele.instrument_type?._id != this.getInstrumentType._id) return false;
        // kmrt：直接以區域比對，該區域沒有儀器時（例如剛新增的區域）顯示空表，而不是列出全部儀器
        if (this.kmrtRole) return ele.area === this.area;
        return selectedInstrumentNames.length > 0 ? selectedInstrumentNames.includes(ele.name) : true;
      });

      for(let i = this.instrumentList.length; i < this.listMinCount;i++){
        this.instrumentList.push(({}));
      }
      this.updateTable();
    },
    async getCascaderInstrumentList(){
      if(this.isContinuityType) return;

      if(this.useLazyInstrumentLoad) {
        this.instrumentLoading = true;
        try {
          await this.expandSelectedCascadeToInstruments();
        } finally {
          this.instrumentLoading = false;
        }
      }
      this.applyInstrumentFilter();
    },
    updateTable() {
      if(this.showOutputTable)
        setTimeout(() => {
          this.$refs.hot?.hotInstance?.loadData(this.instrumentList);
        }, 100);
    },

    shouldShowColumn(key) {
      const instrumentType = this.getInstrumentType;
      // 還沒選儀器類型時，只顯示 constCol
      if (!instrumentType) {
        return this.constCol.includes(key);
      }

      const isLC = instrumentType.name === 'LC (支撐荷重計)';

      // LC (支撐荷重計)：強制顯示 R0 & gage 初值三欄
      if (isLC && ['R0', 'gage1_initial', 'gage2_initial', 'gage3_initial'].includes(key)) {
        return true;
      }

      // 其他欄位依照 InstrumentType 的設定 + constCol
      const insTypeObjKey = Object.keys(instrumentType);
      return (
        (insTypeObjKey.includes(key) && instrumentType[key]) ||
        this.constCol.includes(key)
      );
    },

    showFrequencySettingPanel(instance, row) {
      console.log('test');
      const rowData = instance.getSourceDataAtRow(row);
      this.selectedInstrument = rowData;
      this.frequencySettingDialogVisible = true;
    },

    // 複製既有儀器設定為一筆新的、可編輯的新版本列（不帶 _id/created_at，
    // 因此不會被 cells() 的既有資料鎖定規則鎖住），讓使用者能在既有數值基礎上快速調整。
    copyInstrumentAsNewVersion(row) {
      const rowData = this.$refs.hot.hotInstance.getSourceDataAtRow(row);
      if (!rowData || !rowData.name) return;

      const { _id, created_at, other_value, ...rest } = rowData;
      const newRow = { ...rest, startDate: '' };
      if (other_value) {
        newRow.other_value = { ...other_value };
      }

      // 插入在來源列正下方，而非整個列表最後（最後面還有一大段預設的空白列），
      // 避免使用者複製後要往下滑過一堆空白列才找得到新版本，造成畫面割裂感。
      this.instrumentList.splice(row + 1, 0, newRow);
      this.updateTable();
      this.$notifySuccess(`已複製「${rowData.name}」的設定為新版本，請至該列下方填寫初值日期後儲存`);
    },

    async handleSaveFrequencySetting(data) {
      try {
        await this.$axios({
          category: 'manual',
          method: 'post',
          apiName: 'updatedTimeoutSetting',
          data: {
            instrument_id: data.instrumentId,
            settingData: data.settingData,
            //setting_id: this.frequencySettingPanel.settingData._id,
            //setting_start_date: this.frequencySettingPanel.settingData.start_date,
            //setting_end_date: this.frequencySettingPanel.settingData.end_date,
            //setting_type: this.frequencySettingPanel.settingData.setting_type,
          },
        });

        this.$message.success('儲存成功');
        this.frequencySettingDialogVisible = false;

        await this.getInstruments();
        this.applyInstrumentFilter();
      } catch (error) {
        console.error('儲存失敗:', error);
        this.$message.error('儲存失敗，請稍後再試');
      }
    },

    isLCInstrumentType(type = this.getInstrumentType) {
      const name = (typeof type === 'string' ? type : type?.name) || '';
      // 兼容：'LC (支撐荷重計)' / 'LC 支撐荷重計' 等
      return name.includes('LC') && name.includes('支撐荷重計');
    },

    // 該版本（data[N]）是否已超過建立後 24 小時的可編輯窗口（與角色無關，純時間判斷）
    isPastEditWindow(rowData) {
      if (!rowData?.created_at) return false;
      const elapsedSeconds = (Date.now() - new Date(rowData.created_at).getTime()) / 1000;
      return elapsedSeconds > 60 * 60 * 24;
    },
  },
};
</script>
  
<style>
.htBtn {
  background-color: #409eff;
  color: white;
  border: none;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.htBtn:hover:not(:disabled) {
  background-color: #66b1ff;
}

.htBtn-disabled {
  background-color: #c0c4cc !important;
  color: #909399 !important;
  cursor: not-allowed !important;
}

.htBtn:disabled {
  background-color: #c0c4cc;
  color: #909399;
  cursor: not-allowed;
}

.station-conflict-confirm .el-message-box__message p {
  white-space: pre-line;
}

.client-locked-cell {
  background-color: #FDF6EC !important;
}
</style>
